<template>
    <v-row class="fill-height" align="center" justify="center" >
        <v-card>
            <v-card-title>
                <span>You are not authorised to access that page.</span>
            </v-card-title>
        </v-card>
    </v-row>
</template>

<script>
export default {
    components: {

    },
    data() {
        return {
            show: true
        };
    }
};
</script>